export default {
    name: 'priceFilter',
    component() {
        return {
            selectedIndex: -1,
            form: null,
            
            init() {
                this.form = this.$el.closest('form');
                // Check which range is currently active
                // Note: URL values are in euros, but we compare with cents
                // Use this.$root to scope queries to this specific filter instance (fixes mobile/desktop duplicate)
                const minInput = this.$root.querySelector(`[name='${this.$root.dataset.paramMin}']`);
                const maxInput = this.$root.querySelector(`[name='${this.$root.dataset.paramMax}']`);

                if (minInput && minInput.value) {
                    const currentMin = parseFloat(minInput.value) * 100; // Convert euros to cents
                    const currentMax = maxInput && maxInput.value ? parseFloat(maxInput.value) * 100 : null;
                    
                    const ranges = [
                        {min: 100, max: 10000},
                        {min: 10000, max: 50000},
                        {min: 50000, max: 100000},
                        {min: 100000, max: 250000},
                        {min: 250000, max: 500000},
                        {min: 500000, max: null}
                    ];
                    
                    ranges.forEach((range, index) => {
                        if (range.min == currentMin && (range.max == currentMax || (range.max === null && currentMax === null))) {
                            this.selectedIndex = index;
                        }
                    });
                }
            },

            selectRange(min, max, index) {
                // Use this.$root to scope queries to this specific filter instance (fixes mobile/desktop duplicate)
                const minInput = this.$root.querySelector(`[name='${this.$root.dataset.paramMin}']`);
                const maxInput = this.$root.querySelector(`[name='${this.$root.dataset.paramMax}']`);
                const checkbox = this.$root.querySelector(`#price-range-${index}`);
                
                if (this.selectedIndex === index) {
                    // Deselect current range
                    this.selectedIndex = -1;
                    if (minInput) minInput.value = '';
                    if (maxInput) maxInput.value = '';
                    if (checkbox) checkbox.checked = false;
                } else {
                    // Uncheck all other checkboxes first (scoped to this filter instance)
                    this.$root.querySelectorAll('[id^="price-range-"]').forEach(cb => cb.checked = false);
                    
                    // Select new range
                    // Convert cents to euros (divide by 100)
                    this.selectedIndex = index;
                    if (checkbox) checkbox.checked = true;
                    if (minInput) minInput.value = min / 100;
                    if (maxInput) {
                        if (max !== null) {
                            maxInput.value = max / 100;
                        } else {
                            maxInput.value = '';
                        }
                    }
                }
                
                // Auto-submit the form
                if (this.form) {
                    // Ensure sort_by is preserved if it exists in URL
                    const urlParams = new URLSearchParams(window.location.search);
                    const sortBy = urlParams.get('sort_by');
                    if (sortBy) {
                        // Check if sort_by input already exists
                        let sortInput = this.form.querySelector('input[name="sort_by"]');
                        if (!sortInput) {
                            sortInput = document.createElement('input');
                            sortInput.type = 'hidden';
                            sortInput.name = 'sort_by';
                            this.form.appendChild(sortInput);
                        }
                        sortInput.value = sortBy;
                    }
                    this.form.submit();
                }
            }
        }
    }
}